import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';//para pasar datos de regreso desde aca del modal
import * as firebase from 'firebase'

@Component({
  selector: 'app-modal-data-usuario',
  templateUrl: './modal-data-usuario.component.html',
  styleUrls: ['./modal-data-usuario.component.scss']
})
export class ModalDataUsuarioComponent implements OnInit, OnChanges {

  @Input() public cedula;

  dataDeRegreso="holi desde el modal"//esto no lo estamos usando pero es para tenerlo ahi 

  datausuario=null;


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.queryUsuario()
  }

  ngOnChanges(){
    console.log("ngOnChanges activado")
  }

  queryUsuario(){
    firebase.firestore().collection("datausuarios").doc(this.cedula).get().then((doc)=> {
    if (doc.exists) {
        this.datausuario=doc;
    } else {
        
    }
    }).catch((error)=> {
      
    });
  }

  cerrar(){
    this.activeModal.close(this.dataDeRegreso);//esto no lo estamos usando pero es para tenerlo ahi 
  }

}


